import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

export const useDate = () => {
  dayjs.extend(localizedFormat);

  const format = (date: dayjs.ConfigType, format: string) => dayjs(date).format(format);

  return {
    dayjs,
    format
  };
};
